import { Box, ModalCloseButton, usePrevious } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import {
  TransactionError,
  TransactionPending,
} from '@ui/components/TransactionDrawer';
import { useTranslations } from '@ui/i18n';
import { gardenTokenDict, getGardenName } from '@ui/utils/garden';
import { useEffect } from 'react';

import { DefaultContent } from './DefaultContent';
import { SuccessContent } from './SuccessContent';
import { useGardenPlantDrawer } from './useGardenPlantDrawer';
import { GARDEN_PLANT_STEP, useGardenPlant } from './utils';

export const GardenPlantDrawer = () => {
  const t = useTranslations();
  const coinMode = useGardenPlantDrawer((s) => s.coinMode);
  const isOpen = useGardenPlantDrawer((s) => s.isOpen);
  const isWithdraw = useGardenPlantDrawer((s) => s.isWithdraw);
  const step = useGardenPlantDrawer((s) => s.step);
  const gardenType = useGardenPlantDrawer((s) => s.gardenType);
  const onClose = useGardenPlantDrawer((s) => s.onClose);
  const error = useGardenPlantDrawer((s) => s.error);
  const plantDirectly = useGardenPlantDrawer((s) => s.plantDirectly);
  const confirmStep = useGardenPlantDrawer((s) => s.confirmStep);
  const confirmStepTotal = useGardenPlantDrawer((s) => s.confirmStepTotal);

  const { mutateAsync: doPlant } = useGardenPlant();
  const isPreviousOpen = usePrevious(isOpen);

  useEffect(() => {
    if (!isPreviousOpen && isOpen && plantDirectly) {
      doPlant();
    }
  }, [doPlant, isOpen, isPreviousOpen, plantDirectly]);

  return (
    <ModalOrDrawer
      variant="wholeScreen"
      placement="bottom"
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'full',
        desktop: 'md',
      }}
    >
      <ModalOrDrawerOverlay bg="bg-gauze" />
      <ModalOrDragDrawerContent>
        <InDesktop>
          <ModalCloseButton />
        </InDesktop>
        <ModalOrDrawerHeader>
          {isWithdraw
            ? t('Withdraw {coin}', {
                coin: gardenTokenDict[coinMode][gardenType].name,
              })
            : t('Plant {coin}', {
                coin: gardenTokenDict[coinMode][gardenType].name,
              })}
          <Box mt="3px" color="text-light" textStyle="caption">
            {getGardenName(coinMode, gardenType)}
          </Box>
        </ModalOrDrawerHeader>
        {step === GARDEN_PLANT_STEP.default && <DefaultContent />}
        {step === GARDEN_PLANT_STEP.confirming && (
          <TransactionPending.Content
            nSteps={confirmStepTotal}
            currentStep={confirmStep}
          />
        )}
        {step === GARDEN_PLANT_STEP.failed && (
          <TransactionError.Content error={error} mx="16px" />
        )}
        {step === GARDEN_PLANT_STEP.success && <SuccessContent />}
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
